__turbopack_context__.v({
  "banner": "policy-module__UBCqGq__banner",
  "date": "policy-module__UBCqGq__date",
  "desc_para": "policy-module__UBCqGq__desc_para",
  "description_section": "policy-module__UBCqGq__description_section",
  "link_wrapper": "policy-module__UBCqGq__link_wrapper",
  "menu__item": "policy-module__UBCqGq__menu__item",
  "privacy_container": "policy-module__UBCqGq__privacy_container",
  "privacy_content": "policy-module__UBCqGq__privacy_content",
  "privacy_menu": "policy-module__UBCqGq__privacy_menu",
  "sub_title": "policy-module__UBCqGq__sub_title",
  "title": "policy-module__UBCqGq__title",
});
